import _isString from 'lodash/isString';
import _sortBy from 'lodash/sortBy';

export const SORT_DIRECTIONS = {
  ASC: 'asc',
  DESC: 'desc',
};

export const sortBody = (body, column, direction) => {
  const data = _sortBy(body, (item) => {
    const sortItem = item[column].customSort ?? item[column].text;
    return _isString(sortItem) ? sortItem.toLowerCase() : sortItem;
  });

  if (direction === SORT_DIRECTIONS.DESC) {
    data.reverse();
  }

  return data;
};

export const formatData = (config, data, isMobile) => {
  const names = Object.keys(config);

  return data.map((row) => {
    const formattedRow = {
      rowValue: row,
    };

    names.map((name, index) => {
      const {
        isLink: configIsLink,
        linkUrl,
        newTabOnClick,
        isHiddenMobile,
        subDataMobile,
        isHiddenLink,
        pageIndex,
        linkTitle,
        customSortByField,
        customRender,
        customWidth,
      } = config[name];

      let noIndex = false;
      let isLink = false;

      const text = row[name];
      const mobileText = row[subDataMobile];
      const displayData = isMobile ? mobileText || text : text;
      if (row.indexedLink === true && index === 1 && row[linkUrl]) {
        isLink = true;
      } else if (row.jobTitleIndexes && pageIndex && row.jobTitleIndexes[pageIndex] === 'INDEX') {
        isLink = true;
      } else if ((row.indexedLink === false && index === 1) || !row[linkUrl]) {
        isLink = false;
      } else if (row.jobTitleIndexes && pageIndex && row.jobTitleIndexes[pageIndex] === 'NOINDEX') {
        isLink = false;
      }

      if (row.indexedLink === false) {
        noIndex = true;
      }
      if (
        pageIndex &&
        pageIndex === 'indexInfoOfCompanyPage' &&
        name === 'company' &&
        row.companyIndexedLink === true
      ) {
        noIndex = false;
      }

      const isDataLink =
        (isLink || configIsLink === true || row[configIsLink]) &&
        !(isHiddenLink || row[isHiddenLink] || noIndex);

      const style = {};

      if (customWidth) style.width = customWidth;

      //calculating max width
      switch (names.length) {
        case 1:
          style.maxWidth = '100%';
          break;
        case 2:
          style.maxWidth = '355px';
          break;
        case 3:
          style.maxWidth = '230px';
          break;
        case 4:
          style.maxWidth = '167px';
          break;
        case 5:
          style.maxWidth = '130px';
          break;
        case 6:
        default:
          style.maxWidth = '130px';
          break;
      }
      const col = {
        isLink: isDataLink,
        linkUrl: row[linkUrl],
        text: displayData,
        linkTitle: row[linkTitle],
        newTab: newTabOnClick,
        isHiddenMobile,
        style,
        customSort: row[customSortByField],
        customRender: customRender ? () => customRender(row) : undefined
      };
      Object.keys(col).map((key) => (col[key] === undefined ? delete col[key] : {}));

      formattedRow[name] = col;
    });

    return formattedRow;
  });
};
